<template>
    <div class="bg-slate-50 border-slate-200 rounded-lg w-full p-3 border">
        <p class="text-black leading-6">
            <i18next :translation="$t(langPath)">
                <template #link>
                    <a
                        :href="route('landing-page.show', { slug: $t('common:communityGuidelinesPageSlug') })"
                        class="cursor-pointer text-blue-600"
                        target="_blank"
                    >
                        {{ $t('common:communityGuidelines') }}
                    </a>
                </template>
            </i18next>
        </p>
    </div>
</template>

<script>
import route from '@router/route';
/**
 * Shows variations of text for nsfw posts and comments,
 * formats different translations to community guidelines page.
 * */
export default {
    name: 'NsfwText',
    i18nOptions: { namespaces: ['common'] },
    props: {
        langPath: {
            type: String,
            required: true,
        },
    },
    methods: {
        route,
    },
};
</script>
